var _path, _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.825 2.37135C13.825 3.46695 12.9489 4.34748 11.8568 4.34748C10.7629 4.34748 9.88064 3.46523 9.88064 2.37135C9.88064 1.27748 10.7629 0.395226 11.8568 0.395226C12.9489 0.395226 13.825 1.27576 13.825 2.37135ZM7.50138 2.37135C7.50138 3.46695 6.62531 4.34748 5.53316 4.34748C4.43929 4.34748 3.55703 3.46523 3.55703 2.37135C3.55703 1.27748 4.43929 0.395226 5.53316 0.395226C6.62531 0.395226 7.50138 1.27576 7.50138 2.37135ZM0.395226 9.09019C0.395226 8.77498 0.550016 8.46979 0.873502 8.17146C1.19969 7.87064 1.67033 7.60425 2.22276 7.38318C3.32827 6.94079 4.66165 6.71884 5.53316 6.71884C6.40467 6.71884 7.73805 6.94079 8.84356 7.38318C9.39599 7.60425 9.86663 7.87064 10.1928 8.17146C10.5163 8.46979 10.6711 8.77498 10.6711 9.09019V10.6711H0.395226V9.09019ZM13.0424 9.09019C13.0424 8.13503 12.6654 7.35224 12.092 6.72378C12.9564 6.75873 14.1569 6.97891 15.1672 7.38318C15.7196 7.60425 16.1902 7.87064 16.5164 8.17146C16.8399 8.46979 16.9947 8.77498 16.9947 9.09019V10.6711H13.0424V9.09019Z",
    fill: "#6E7389",
    stroke: "#6E7389",
    strokeWidth: 0.790451
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2075_2414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.53314,
    y: 7.83325,
    width: 18.3306,
    height: 12.6472,
    rx: 3.79417,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.32359,
    y: 8.62366,
    width: 16.7497,
    height: 11.0663,
    fill: "#6E7389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7549 7.4104H8.26638C7.33061 7.4104 6.58874 8.16051 6.58874 9.09604L6.58031 19.2099C6.58031 20.1454 7.33061 20.8955 8.26638 20.8955H21.7549C22.6907 20.8955 23.441 20.1454 23.441 19.2099V9.09604C23.441 8.16051 22.6907 7.4104 21.7549 7.4104ZM12.06 16.6814H11.0484L8.89865 13.7315V16.6814H7.84486V11.6245H8.89865L11.0062 14.5744V11.6245H12.06V16.6814ZM16.2752 12.6864H14.1676V13.6304H16.2752V14.6924H14.1676V15.6279H16.2752V16.6814H12.9031V11.6245H16.2752V12.6864ZM22.1764 15.8386C22.1764 16.3021 21.7971 16.6814 21.3334 16.6814H17.9613C17.4976 16.6814 17.1182 16.3021 17.1182 15.8386V11.6245H18.172V15.4256H19.1247V12.4589H20.1785V15.4172H21.1227V11.6245H22.1764V15.8386Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.92837,
    y: 8.22848,
    width: 17.5401,
    height: 11.8568,
    rx: 3.39894,
    stroke: "#6E7389",
    strokeWidth: 0.790451
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2075_2414"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.53314,
    y: 7.83325,
    width: 18.3306,
    height: 12.6472,
    rx: 3.79417,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.74da469a22729ff7a7afb8b2330e0b7d.svg";
export { ForwardRef as ReactComponent };